module.exports = __webpack_public_path__ + "img/drive1.461cd088.png";